import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';
import { adminProfile, clientProfile } from '../../services/admin';

// Actions

// ----------------------------------------------------------------------



// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

const initialState = {
  isLoading: true,
  data: [],
};

const slice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // END LOADING
    endLoading(state) {
      state.isLoading = true;
    },
    setSettings(state , action){
      state.isLoading = false;
      state.data = action.payload;
    }
  },
  // extraReducers: (builder) => {
  //   builder

  //     .addCase(getAdminProfile.pending, (state, action) => {
  //       state.isLoading = true;
  //     })
  //     .addCase(getAdminProfile.rejected, (state, action) => {
  //       state.isLoading = false;
  //     })
  //     .addCase(getAdminProfile.fulfilled, (state, action) => {
  //       state.isLoading = false;
  //       state.data = action.payload;
  //     });
  // },
});

// Reducer
export default slice.reducer;
// Actions
export const {
  setSettings,
} = slice.actions;

